// extracted by mini-css-extract-plugin
export default {"help":"styles_help__FE2LS","title":"styles_title__fTvvY","sbp-logo":"styles_sbp-logo__uGAA7","text":"styles_text__ttLcw","button-wrapper":"styles_button-wrapper__nHa9s"};